import { Component, OnInit } from '@angular/core';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';
import { NgControl, FormBuilder, Validators } from '@angular/forms';
import { PrevailingWageInformation } from '../prevailing-wage.models';
import { filterStates } from 'src/shared/utilities/utility-functions';
import { phoneMask } from 'src/shared/constants';
import { CustomValidators } from 'src/shared/validators/custom-validators';

const prevailingWageInfoFormConfig: FormConfig<PrevailingWageInformation> = {
	id: [''],
	projectName: [''],
	projectNumber: [''],
	city: [''],
	county: [''],
	state: [''],
	certifiedPayrollReportsRequired: [''],
	payrollReportsName: [''],
	payrollReportsPhone: ['', [CustomValidators.isPossiblyValidPhone]],
	payrollReportsEmail: ['', [Validators.email]],
	confirmedBy: [''],
	confirmedDate: [''],
};

@Component({
	selector: 'rpfsa-prevailing-wage-info',
	templateUrl: './prevailing-wage-info.component.html',
})
export class PrevailingWageInformationComponent
	extends CustomFormAccessor<PrevailingWageInformation>
	implements OnInit {
	phoneMask = { mask: phoneMask };
	filteredStates$ = filterStates(this.form.get('state'));

	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, prevailingWageInfoFormConfig);
	}
}
